module.exports = __webpack_public_path__ + "static/media/TWELVE.4454bf57.png";